module.exports = __webpack_public_path__ + "static/1.de7c9ab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/1.jpg
// module id = 484
// module chunks = 76778261247453